/**
 * Single source of truth for Penning's registered company details.
 *
 * Any company address / legal-name / CVR text shown to users (site footer,
 * invoices, client agreement, …) is derived from here, so the registered
 * address only ever has to be changed in one place.
 */

export const COMPANY_LEGAL_NAME = 'Penning Financial Services ApS'

/** Danish CVR / company registration number. */
export const COMPANY_CRN = 'DK44645971'

export const COMPANY_ADDRESS = {
  street: 'Frederiksgaards Allé 16A, st. th.',
  postalCode: '2720',
  city: 'Vanløse',
  /** English country name, for English-language legal copy. */
  countryEn: 'Denmark',
  /** Danish country name, for invoices. */
  countryDa: 'Danmark',
} as const

const { street, postalCode, city, countryEn, countryDa } = COMPANY_ADDRESS

/** "2720 Vanløse" — postal code followed by city. */
export const COMPANY_POSTAL_CITY = `${postalCode} ${city}`

/**
 * Footer address block, one string per rendered line:
 * legal name, street, then postal code + city.
 */
export const COMPANY_ADDRESS_LINES = [
  COMPANY_LEGAL_NAME,
  street,
  COMPANY_POSTAL_CITY,
]

/**
 * English inline address (comma separated) for legal documents, e.g.
 * "Frederiksgaards Allé 16A, st. th., 2720 Vanløse, Denmark".
 */
export const COMPANY_ADDRESS_INLINE = `${street}, ${COMPANY_POSTAL_CITY}, ${countryEn}`

/**
 * Danish single-line company/legal footer for invoices, e.g.
 * "Penning Financial Services ApS - Frederiksgaards Allé 16A, st. th. - 2720
 * Vanløse - Danmark - CVR-nr.: DK44645971".
 */
export const COMPANY_INVOICE_LEGAL_LINE = `${COMPANY_LEGAL_NAME} - ${street} - ${COMPANY_POSTAL_CITY} - ${countryDa} - CVR-nr.: ${COMPANY_CRN}`
